import { Helmet } from "react-helmet";

const ContactUs = () => {
    return (
      <>
      <Helmet>
      <title>Contact Us</title>
      </Helmet>
        <main className="max-w-7xl mx-auto px-3 md:px-7 lg:px-2 flex flex-col-reverse lg:flex-row-reverse gap-6">
          {/* ================= Sticky section ================ */}
          <section>
            <div className="md:w-96 lg:w-64 bg-blue p-6 lg:p-4  rounded-lg sw-one sticky top-36 mx-auto">
              <h2 className="text-xl font-bold text-white text-center">
                Get Project Estimation
              </h2>
              <form className="mt-6 lg:mt-3">
                <input
                  className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full"
                  type="text"
                  placeholder="Name"
                />
                <input
                  className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full my-4"
                  type="email"
                  placeholder="Email"
                />
                <input
                  className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full "
                  type="number"
                  placeholder="Phone number"
                />
                <select className=" outline-none px-2 rounded py-1.5 lg:py-0.5 w-full my-4">
                  <option disabled="" selected="">
                    Select Budget
                  </option>
                  <option>USD 2000 - USD 5000</option>
                  <option>USD 5000 - USD 10000</option>
                  <option>USD 10000 - USD 20000</option>
                  <option>USD 20000 - USD 40000</option>
                  <option>USD 40000 - USD 60000</option>
                  <option>USD 60000 - USD 90000</option>
                  <option>USD 90000 - USD 130000</option>
                  <option>USD 130000 - USD 200000</option>
                  &gt;
                </select>
                <textarea
                  className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full"
                  placeholder="message"
                  rows={3}
                  defaultValue={""}
                />
                <button className="text-white bg-black px-6 mt-2 py-2 lg:py-1 rounded-md w-full font-medium">
                  Submit
                </button>
              </form>
            </div>
          </section>
          {/* ================= Main section ================== */}
          <section>
            {/* ================== Hero section ================= */}
            <section className="flex flex-col-reverse lg:flex-row items-center mt-10 ">
              <div>
                <h1 className="text-3xl md:text-5xl lg:text-7xl font-black  mt-4 lg:mt-0">
                  We're here <br className="hidden lg:block" /> to help!
                </h1>
              </div>
              <div className="flex-1">
                <img className="w-full" src="image/contact-hero-img.webp" alt="" />
              </div>
            </section>
            {/* ======== contact========== */}
            <section className="mt-20 md:mt-32">
              <div className="grid grid-cols-10 gap-8">
                <div className="col-span-10 lg:col-span-4 flex flex-col gap-8 sw-two rounded-lg px-8 py-12">
                  <div className="flex gap-4 items-center">
                    <i className="fa-solid fa-phone bg-blue p-3 text-white rounded-lg" />
                    <p className="text-xl">+0545456565</p>
                  </div>
                  <div className="flex gap-4 items-center">
                    <i className="fa-brands fa-whatsapp bg-blue p-3 text-white rounded-lg" />
                    <p className="text-xl ">WhatsApp</p>
                  </div>
                  <div className="flex gap-4 items-center">
                    <i className="fa-solid fa-envelope bg-blue p-3 text-white rounded-lg" />
                    <p className="text-xl ">Info@insurancecart.ae</p>
                  </div>
                  <div className="flex gap-4 items-center">
                    <i className="fa-solid fa-location-dot bg-blue p-3 text-white rounded-lg" />
                    <p className="text-xl ">
                      Zentral Building, Dubai World Trade Centre - Sheikh Zayed Rd -
                      Trade Centre - Trade Centre 2 - Dubai - United Arab Emirates
                    </p>
                  </div>
                </div>
                {/* =====second div===== */}
                <div className="col-span-10 lg:col-span-6 px-8 py-12 sw-two rounded-lg">
                  <div className="flex items-center gap-4">
                    <p className="text-lg font-medium">Type of Assistance:</p>
                    <div className="form-control">
                      <label className="label cursor-pointer">
                        <input
                          type="radio"
                          name="radio-10"
                          className="radio radio-info radio-sm"
                          defaultChecked=""
                        />
                        <span className="label-text ms-4 ">Support</span>
                      </label>
                    </div>
                    <div className="form-control">
                      <label className="label cursor-pointer">
                        <input
                          type="radio"
                          name="radio-10"
                          className="radio radio-info radio-sm"
                          defaultChecked=""
                        />
                        <span className="label-text ms-4 ">Information</span>
                      </label>
                    </div>
                  </div>
                  <form className="grid grid-cols-2 gap-8 mt-6">
                    <input
                      type="text"
                      name="subject"
                      placeholder="Subject"
                      className="col-span-2 md:col-span-1 input input-bordered h-10 w-full input-info text-base"
                      required=""
                    />
                    <textarea
                      className="col-span-2 md:col-span-1 textarea textarea-info  md:row-span-3"
                      placeholder="message..."
                      defaultValue={""}
                    />
                    <input
                      type="text"
                      name="name"
                      placeholder="Name"
                      className="col-span-2 md:col-span-1 input input-bordered h-10 w-full input-info text-base"
                      required=""
                    />
                    <input
                      type="number"
                      name="number"
                      placeholder="Number"
                      className="col-span-2 md:col-span-1 input input-bordered h-10 w-full input-info text-base"
                      required=""
                    />
                    <div className="col-span-2 flex justify-center md:justify-end">
                      <button className="bg-blue px-6 py-1.5 rounded-lg text-white ">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </section>
          </section>
        </main>
      </>
    )
}

export default ContactUs;